import { render, staticRenderFns } from "./FormationUniversitaire.vue?vue&type=template&id=0155be26"
import script from "./FormationUniversitaire.vue?vue&type=script&lang=js"
export * from "./FormationUniversitaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports